import { Component, computed, effect, inject, input, signal } from '@angular/core';
import { IncidentSeverityCountComponent } from '@incidents';
import { IncidentSeverity } from '@models';
import { EntityStatusComponent, StatusCountComponent } from '@ui';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { WidgetSpaceDetails } from '../../../models';
import { DashboardStore } from '../../../stores';

@Component({
  imports: [
    NgxSkeletonLoaderModule,
    EntityStatusComponent,
    IncidentSeverityCountComponent,
    StatusCountComponent,
  ],
  selector: 'avs-space-details',
  styleUrl: './space-details.component.scss',
  templateUrl: './space-details.component.html',
})
export class SpaceDetailsComponent {
  config = input.required<WidgetSpaceDetails>();

  protected eInicidentSeverity = IncidentSeverity;
  protected space = computed(() => this.spaceState() ?? this.locationState() ?? null);

  private store = inject(DashboardStore);
  private locationKey = signal('');
  private spaceKey = signal('');
  private locationState = computed(() => this.store.locationInfo(this.locationKey())());
  private spaceState = computed(() => this.store.spaceInfo(this.spaceKey())());

  constructor() {
    effect(() => {
      const spaceId = this.config().roomId || this.config().floorId;

      if (spaceId) {
        this.spaceKey.set(this.store.loadSpaceInfo(this.config().locationId, spaceId));
        this.locationKey.set('');
      } else {
        this.locationKey.set(this.store.loadLocationInfo(this.config().locationId));
        this.spaceKey.set('');
      }
    });
  }
}
